<ion-header>
  <ion-toolbar>
    <ion-title>{{ 'tenantSwitcher.title' | translate }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()" [attr.aria-label]="'tenantSwitcher.close' | translate">
        <ion-icon name="close" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
  <ion-toolbar>
    <ion-searchbar
      [placeholder]="'tenantSwitcher.searchPlaceholder' | translate"
      [(ngModel)]="search"
      (ionInput)="applyFilter()"
    debounce="0"></ion-searchbar>
  </ion-toolbar>
</ion-header>

<ion-content>
  @if (loading) {
    <div class="ion-padding ion-text-center">
      <ion-spinner color="primary"></ion-spinner>
    </div>
  }

  @if (error) {
    <div class="ion-padding ion-text-center" style="color: var(--ion-color-danger)">
      {{ 'tenantSwitcher.loadError' | translate }}
    </div>
  }

  @if (!loading && !error) {
    <ion-list>
      @for (t of filtered; track t) {
        <ion-item
          button
          detail="false"
          (click)="select(t)">
          <ion-icon
            slot="start"
            [name]="t.id === activeId ? 'checkmark-circle' : 'business-outline'"
          [color]="t.id === activeId ? 'primary' : 'medium'"></ion-icon>
          <ion-label>
            <h2>{{ t.name || t.id }}</h2>
            <p>{{ t.tenantCode || t.id }}@if (!t.isActive) {
              <span> · {{ 'tenantSwitcher.inactive' | translate }}</span>
            }</p>
          </ion-label>
        </ion-item>
      }
      @if (filtered.length === 0) {
        <ion-item lines="none">
          <ion-label class="ion-text-center" color="medium">{{ 'tenantSwitcher.noResults' | translate }}</ion-label>
        </ion-item>
      }
    </ion-list>
  }
</ion-content>
